import { useState } from "react";
import { createGmail } from "../../../../../api/EmailAPI";
import { defaultSMTPConfigs } from "../../../tools/emails/components/defaultConfigs";
import { useParams } from "react-router-dom";
import { getTypeIcon } from "../../../workflows/CreateCampaign/flow/flowSettings";
import { Button, Tooltip } from "@mantine/core";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { modals } from "@mantine/modals";
import EmailSendingModal from "./EmailSendingModal";

const CreateGmail = ({
  buttonProps,
  iconSize = 18,
  onCreated,
  setTableLoading,
}) => {
  const lang = useLanguage((s) => s.language);
  const { poolId } = useParams();
  const [loading, setLoading] = useState(false);

  const handleGmail = () => {
    setLoading(true);
    createGmail({
      data: {
        ...defaultSMTPConfigs,
        pools_ids: poolId ? [parseInt(poolId)] : undefined,
      },
    })
      .then((response) => {
        if (response.data?.email_account?.redirect_url) {
          window.open(response.data?.email_account?.redirect_url, "_self");
        }
        setLoading(false);
        onCreated?.();
        // modals.open({
        //   modalId: "gmail",
        //   size: "xl",
        //   title: lang.senders.emails.google_modal_title,
        //   children: (
        //     <EmailSendingModal
        //       setTableLoading={setTableLoading}
        //       id={response.data?.email_account?.id}
        //       type={"Gmail"}
        //     />
        //   ),
        // });
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <Tooltip label={lang.senders.emails.google_tooltip} position="left">
      <Button
        leftSection={getTypeIcon(
          "Gmail",
          false,
          iconSize,
          { variant: "subtle" },
          true
        )}
        onClick={handleGmail}
        variant="subtle"
        w={"100%"}
        justify="start"
        size="md"
        c={"var(--mantine-color-gray-7)"}
        // size={inMenu ? "sm" : "md"}
        // fw={inMenu ? 600 : 500}
        loading={loading}
        {...buttonProps}
      >
        Gmail
      </Button>
    </Tooltip>
  );
};

export default CreateGmail;
